import { loadable } from 'utils';

export const OrderLineSelection = loadable(() => import('./OrderLineSelection'), {});
export const RequestType = loadable(() => import('./RequestType'), {});
export const RevertItems = loadable(() => import('./RevertItems'), {});
